import React, { Component, ReactNode } from 'react'
import './Row.css'

type RowColumn = 1 | 2 | 3 | 4
type RowColumnClass = 'one-column' |
  'two-column' |
  'three-column' |
  'four-column'
type RowColumnClasses = Record<RowColumn, RowColumnClass>

interface RowProps {
  column: RowColumn
  children: ReactNode
}

export default class Row extends Component<RowProps> {
  columnClasses: RowColumnClasses = {
    1: 'one-column',
    2: 'two-column',
    3: 'three-column',
    4: 'four-column'
  }

  get className () {
    const base = this.columnClasses[this.props.column]
    return `${base}`
  }

  render () {
    return (
      <div className={this.className}>
        {this.props.children}
      </div>
    )
  }
}
